var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGreenPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.7 6.3H14V7.7H7.7V14H6.3V7.7H0V6.3H6.3V0H7.7V6.3Z",
  fill: "#21AE84"
})));
export { SvgGreenPlus as ReactComponent };
export default __webpack_public_path__ + "3596bb7da428d614d3d6a71c1770092e.svg";